import {Component} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {GtmService} from "../../service/gtm/gtm.service";
import { Observable } from "rxjs";

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss'],
})
export class ReservationComponent {

  qparams: any;
  category: string;
  categoryTitle = {
    'rooms' : '회의실 예약',
    'spaces': '대관 신청',
  };

  constructor(private route: ActivatedRoute,
              private gtmService: GtmService) {

    let obsComb = Observable.combineLatest(this.route.params, this.route.queryParams,
      (params, qparams) => ({ params, qparams }));

    obsComb.subscribe( async ({params, qparams}) => {
      this.qparams = qparams;
      this.category = params['category'];

      this.gtmService.pageViewWithPage({
        'path': this.route.snapshot['_routerState'].url,
        'title': this.categoryTitle[this.category],
        'breadcrumb': 'Home > Member > Reservation'
      });

    });
  }
}



// WEBPACK FOOTER //
// ./src/app/member/reservation/reservation.component.ts